module.exports = __webpack_public_path__ + "img/yishi1.fa8bfe8c.jpg";